import { utcToZonedTime } from 'date-fns-tz'

import { TIMEZONE } from '../../../constants'

let brazeInstance: typeof import('@braze/web-sdk') | null = null

const apiKey = process.env.VITE_BRAZE_API_KEY
const baseUrl = process.env.VITE_BRAZE_SDK_END_POINT

export const initBraze = async () => {
  if (!apiKey || !baseUrl) {
    return
  }

  const braze = await import('@braze/web-sdk')
  brazeInstance = braze.default ?? braze

  brazeInstance.initialize(apiKey, {
    baseUrl,
  })
  brazeInstance.openSession()
}

export const logCustomEvent = async <T>(
  eventName: string,
  properties?: Record<string, T>
) => {
  if (!brazeInstance) return
  brazeInstance.logCustomEvent(eventName, properties)
}

export const changeUser = async (userId: string) => {
  if (!brazeInstance) return
  brazeInstance.changeUser(userId)
}

type OptionDetail = {
  id: number
  quantity: number
  price: number
  total: number
}

type ReservationLogParams = {
  price: number
  propertySlug: string
  quantity?: number
  planId?: number
  options?: OptionDetail[]
}

type CouponLogParams = {
  price: number
  propertySlug: string
  couponId?: number
  couponName?: string
  planId?: number
}

export const logReservation = async ({
  price,
  propertySlug,
  quantity = 1,
  planId,
  options = [],
}: ReservationLogParams) => {
  if (!brazeInstance) return

  const datetime = utcToZonedTime(new Date(), TIMEZONE)
  const properties: Record<string, unknown> = {
    datetime,
    propertySlug,
    planId,
  }

  if (options.length > 0) {
    properties.options = options
  }

  brazeInstance.logPurchase('ホテル予約', price, 'USD', quantity, properties)
}

export const logCoupon = async ({
  price,
  propertySlug,
  couponId,
  couponName,
  planId,
}: CouponLogParams) => {
  if (!brazeInstance) return
  const datetime = utcToZonedTime(new Date(), TIMEZONE)
  brazeInstance.logPurchase(
    'ホテルクーポン',
    price,
    'USD',
    1, // coupon quantity is always set 1
    {
      datetime,
      propertySlug,
      couponId,
      couponName,
      planId,
    }
  )
}
